const initialState = {
  vocabularyList: {},
};

export default {
  namespaced: true,
  state: {
    ...initialState,
  },

  getters: {
    vocabularyList(state) {
      return state.vocabularyList;
    },
    vocabularyListLength(state) {
      return Object.keys(state.vocabularyList).length;
    },
  },

  actions: {
    setVocabularyList ({ dispatch }, vocabularyList) {
      dispatch('setVOCABULARY_LIST', vocabularyList);
    },

    setVOCABULARY_LIST ({ commit }, vocabularyList) {
      commit('setVOCABULARY_LIST', vocabularyList);
    },
  },

  mutations: {
    setVOCABULARY_LIST(state, vocabularyList) {
      state.vocabularyList = vocabularyList;
    },
  },
};
